import { useDeviceType } from "@dash/mq";
import React, { PropsWithChildren } from "react";

export const ScrollableTableFrame: React.FC<PropsWithChildren> = ({ children }) => {
  const { mq } = useDeviceType();

  return (
    <div
      css={{
        overflowX: "auto",
        margin: "0 -1rem",
        [mq("desktop")]: {
          margin: "0 -2rem",
        },
      }}
    >
      <div
        css={{
          display: "inline-block",
          minWidth: "100%",
          boxSizing: "border-box",
          padding: "0 1rem",
          [mq("desktop")]: {
            padding: "0 2rem",
          },
        }}
      >
        {children}
      </div>
    </div>
  );
};
